import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { OrderEntry, PalletFlagsRequest } from '../../../../core/model';

@Injectable({
  providedIn: 'root',
})
export class CartEntryPalletFlagsConnector {
  constructor(private httpClient: HttpClient, private occEndpointsService: OccEndpointsService) {}

  update(userId: string, cartId: string, entry: OrderEntry, palletFlags: PalletFlagsRequest): Observable<any> {
    const url = this.occEndpointsService.buildUrl('cartEntryPalletFlags', {
      urlParams: {
        userId: userId,
        cartCodeOrType: cartId,
        entryNumber: `${entry.entryNumber}`,
      },
    });
    return this.httpClient.put(url, palletFlags);
  }
}
